import { useEffect } from 'react';

export function useMount(mount: () => void) {
  useEffect(() => {
    mount();
    // We need no deps here, to force this useEffect to act as mount/unmount one
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
